<template>
	<v-dialog v-model="dialog" persistent max-width="850">
		<v-card flat class="fullHeight pa-40 textAlignCenter">
			<h2>Matriz de Priorización de Defectos</h2>
			<br>
			
			<table class="priority_table">
				<tr class="p_top_label">
					<td colspan="2" rowspan="2">Defect Prioritisation Matrix</td>
					<td :colspan="mtx.length">Severity Level</td>
				</tr>
				<tr class="p_mfl">
					<td v-for="(v,i) in [1,2,3,4,5]" :key="i">MFL{{v}}</td>
				</tr>
				<tr v-for="(l_x,y) in mtx" :key="y">
					<td v-if="y===0" :rowspan="mtx.length" class="p_side_label">
						<div style="writing-mode: tb; transform: rotate(180deg);white-space: nowrap;'">Estimated Timeframe to Failure</div>
					</td>
					<td class="p_label_y">{{label_y[y]}}</td>
					<td v-for="(v,x) in l_x" :key="x" @click="set(y,x)" :class="[priority_colors['P'+v],get_class({y,x}),'p_cell']">
						P{{v}}
					</td>
				</tr>
			</table>

			<br>
			<div>
				<h3 class="text-align:center">Indicador de prioridad</h3>					
				<table class="priority_table_2" :class="dark_t?'dark':''">
					<thead>
						<tr class="">
							<td>Prioridad</td>
							<td>Definición EGWG</td>
							<td>Complemento Definición EGWG por Escondida</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td :class="[priority_colors['P1']]">P1</td>
							<td>Detención del funcionamiento hsata que se rectifique el defecto. El funcionamiento continua solo con la aprobación del GM</td>
							<td></td>
						</tr>
						<tr>
							<td :class="[priority_colors['P2']]">P2</td>
							<td>Definido a nivel de activo a través del estándar de Asset Integrity de Escondida.<br>La remediación no debe exceder un año. De lo contrario debe existir un proceso de aprobación del aplazamiento de los trabajos de remediación.</td>
							<td></td>
						</tr>
						<tr>
							<td :class="[priority_colors['P3']]">P3</td>
							<td>Definido a nivel de activo a través del estándar de Asset Integrity de Escondida</td>
							<td>La remediación del defecto no debe exceder los 2 años.</td>
						</tr>
						<tr>
							<td :class="[priority_colors['P4']]">P4</td>
							<td>Monitorear a través de inspecciones rutinarias AIMS. (P3 emergente - Considere monitoreo adicional).</td>
							<td>Correciones o preparaciones de menor impacto pueden ser consideradas para remediar hallazgos de esta magnitud.</td>
						</tr>
					</tbody>
				</table>
				<div>Fuente: Grupo Global de Ingeniería BHP (EGWG) y de Elaboración Propiar (Escondida).</div>
				<!-- <fs1-div>
					<div><b>Prioridad 1 (P1):</b> Detención el funcionamiento hasta que se rectifique el defecto/ el funcionamiento continua solo con la aprobación del GM.</div>
					<div><b>Prioridad 2 (P2):</b> Definido a nivel de activo a través del Estándar a nivel Asset (No debe exceder 1 año*).</div>
					<div><b>Prioridad 3 (P3):</b> Definido a nivel de activo a través del Estándar a nivel Asset</div>
					<div><b>Prioridad 4 (P4):</b> Monitorear a través de inspecciones rutinarias AIMS. (P3 emergente – Considere monitoreo adicional).</div>
					<div><b>Prioridad 5 (P5):</b> Monitorear a través de inspecciones rutinarias AIMS.</div>
				</fs1-div> -->
			</div>
			<br>
			<v-btn color="secondary" @click="close()">
				<v-icon></v-icon>
				<span>Cerrar</span>
			</v-btn>
		</v-card>
	</v-dialog>
</template>

<script>
import { priority_mtx as mtx,priority_colors } from '@/objects/general.js';
export default {
	props:{
		dialog: {},
		item: {},
		selectedItem: {},
		edit: { default: true},
		x:{},
		y:{},
	},
  data() {
    return {
			priority_colors,
			mtx,
			label_y:[
				'Failure within 1 year',
				'Failure within 2 years',
				'Failure within 5 years',
				'Failure within 20 years',
				'Failure within 50 years',
			],
    };
	},
	created() { },
  watch: { },
  computed: { },
  methods: {
		canSet(v) { },
		get_class({y,x}){
			if (this.x === x && this.y === y) return 'selected';
			return;
		},
		set(v) {},
		close() { this.$emit('update:dialog', false) },
  },
};
</script>

<style scoped>
	.priority_table {
		margin-left: auto;
		margin-right: auto;
		border-collapse: collapse;
		background-color: #2a3b45;
		border: solid 2px #446071;
		color:white;
		font-weight: bolder;
	}
	.priority_table tbody{
		text-align: center;
	}
	.priority_table tr{
		height: 60px !important;
		border: solid 2px #446071;
	}
	.priority_table td{
		border: solid 2px #446071;
		/* cursor: pointer; */
		/* padding: 12px; */
		/* border-bottom: solid grey 2px; */
	}
	.priority_table td.selected{
		text-decoration: underline;
		font-weight: bolder;
		font-size: 30px;
	}
	.priority_table .p_cell {
		width: 60px;
		color: #002060;
	}
	.priority_table .p_label_y {
		text-align: left;
		width: 120px;
		padding-left: 5px;
	}
	.priority_table .p_side_label {
		text-align: center;
		width: 25px;
		padding: 5px;
	}
	.priority_table .p_mfl {
		height: 25px !important;
	}
	.priority_table .p_top_label {
		height: 45px !important;
	}

	.priority_table_2{
		margin-left: auto;
		margin-right: auto;
		border-collapse: collapse;
		border: solid 2px #446071;
		text-align: left;
	}
	.priority_table_2  tr,
	.priority_table_2  td{
		border: solid 2px #446071;
	}
	.priority_table_2 thead tr:nth-of-type(1){
		text-align: center;
		background-color: #F9792F;
		color: white;
	}
	.priority_table_2.dark tbody tr>td:nth-of-type(1){
		color: black;
	}
	.priority_table_2 tr>td:nth-of-type(1){
		text-align: center;
		font-weight: bolder;
	}
	.priority_table_2 td{
		padding-left: 5px;
		padding-right: 5px;
	}
</style>